export default __webpack_public_path__ + "static/media/voitot.1b6151be.png";